import React, { Component } from 'react';
import moment from 'moment';

import { ROUTES } from 'constants/Routes';
import { RENEW_SUBSCRIPTION_STEPS } from 'constants/Transactions';
import PaidPlan from 'components/transactions/PaidPlan';
import { setSelectedPlan } from 'constants/localStorageManager';
import {
  isProPlan,
  isEssentialPlan,
  isPlanActive,
  isBasicPlan,
} from 'utils/plansHelper';

class RenewPlan extends Component {
  constructor() {
    super();
    this.state = {
      basicPlanSelected: false,
    };
  }

  onBasicPlanSelected = plan => {
    const { id, interval, status } = plan;
    const startDate = new Date();
    const isMonthly = interval === 'monthly';
    const subscriptionLength = isMonthly ? 30 : 365;
    const endDate = moment(startDate).add(subscriptionLength, 'days');
    const billing_rate = isMonthly ? '89' : '1015';
    const plan_data = {
      plan_id: id,
      plan_name: 'basic',
      billing_frequency: interval,
      billing_rate,
      status,
      start_date: startDate,
      end_date: endDate,
    };
    this.onPlanSelected(plan_data);
  };

  onProPlanSelected = plan => {
    const { id, interval, status } = plan;
    const startDate = new Date();
    const isMonthly = interval === 'monthly';
    const subscriptionLength = isMonthly ? 30 : 365;
    const billing_rate = isMonthly ? '129' : '1389';
    const endDate = moment(startDate).add(subscriptionLength, 'days');
    const plan_data = {
      plan_id: id,
      plan_name: 'pro',
      billing_frequency: interval,
      billing_rate,
      status,
      start_date: startDate,
      end_date: endDate,
    };
    this.onPlanSelected(plan_data);
  };

  onPlanSelected = plan => {
    const { location } = this.props;
    setSelectedPlan(plan);
    this.changeStep(location.pathname);
  };

  changeStep = currentPathName => {
    const { history } = this.props;
    const currentStepObj = RENEW_SUBSCRIPTION_STEPS.find(
      step => step.path == currentPathName
    );
    const currentStepNumber = RENEW_SUBSCRIPTION_STEPS.indexOf(currentStepObj);
    const lastStep = currentStepNumber == RENEW_SUBSCRIPTION_STEPS.length - 1;
    if (lastStep) return history.push(ROUTES.DASHBOARD_INDEX);
    const nextStep = RENEW_SUBSCRIPTION_STEPS[currentStepNumber + 1];
    history.push(nextStep.path);
  };

  render() {
    const basicPlanDisabled =
      (isProPlan() || isBasicPlan() || isEssentialPlan()) && isPlanActive();

    return (
      <PaidPlan
        onProPlanSelected={this.onProPlanSelected}
        onBasicPlanSelected={this.onBasicPlanSelected}
        basicPlanDisabled={basicPlanDisabled}
        renew
      />
    );
  }
}

export default RenewPlan;



// WEBPACK FOOTER //
// ./src/components/plan/RenewPlan.js